<header>
  <app-header></app-header>
</header>

  @if (authService.backendLogin() || !authService.isAlreadyLoggedIn()) {
    <div class="loading-container">
      <app-spinner />
    </div>
  }
  @else {
    <mat-drawer-container>
      <mat-drawer #drawer mode="over" [opened]="drawerUtils.drawerState()" (closedStart)="resetSignal()">
        <app-navbar/>
      </mat-drawer>
      <main class="main">
        <router-outlet/>
      </main>
    </mat-drawer-container>
  }



